import React, { Component, Fragment } from 'react'

import UIkit from 'uikit'
import 'uikit/dist/css/uikit.min.css'

import Bullet from '../utilities/bullet'

class Portfolio extends Component {

    constructor(props) {
        super(props)
        this.state = {
            accento: '',
            media: [],
            mediaFiltrato: [],
            currentPage: 1,
            perPage: 9,
            visibile: 'isAll'
        }
    }

    componentDidMount() {
        const { portfolio, coloreAccento } = this.props.sito

        this.setState({
            media: portfolio || [],
            mediaFiltrato: portfolio || [],
            accento: coloreAccento || '#03a9f4'
        })


    }

    filtraMedia(tipo) {

        const { media } = this.state

        let mediaFiltrato = []

        if (tipo === 'isFoto') {
            mediaFiltrato = media.filter(f => f.contentType.includes('image'))
        } else if (tipo === 'isVideo') {
            mediaFiltrato = media.filter(f => f.contentType.includes('video'))
        } else {
            mediaFiltrato = media
        }

        this.setState({
            visibile: tipo,
            mediaFiltrato
        });

    }

    cambiaPagina(numero) {
        this.setState({ currentPage: Number(numero) })
    }

    showLightbox(ind) {

        const { media } = this.state
        let temp = []

        media && media.map(item =>
            temp.push({ source: item.url, caption: item.descBreve })
        )

        UIkit.lightboxPanel({
            items: temp
        }).show(ind);

    }


    render() {

        const { media, mediaFiltrato, currentPage, perPage, accento, visibile } = this.state

        // Logic for displaying current media
        const indexOfLastMedia = currentPage * perPage;
        const indexOfFirstMedia = indexOfLastMedia - perPage;
        const currentMedia = mediaFiltrato.length > 0 && mediaFiltrato.slice(indexOfFirstMedia, indexOfLastMedia);

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(mediaFiltrato.length / perPage); i++) {
            pageNumbers.push(i);
        }


        return (
            <div id="portfolio" className="uk-section uk-section-default uk-section-large">
                <div className="uk-container">

                    <div className="uk-clearfix">
                        <div className="uk-float-right">
                            <ul className="uk-subnav uk-subnav-pill" style={{ marginTop: '5px' }}>
                                <li><div onClick={this.filtraMedia.bind(this, 'isAll')} style={visibile === 'isAll' ? { background: accento, color: '#fff', cursor: 'default' } : { background: '#fff', cursor: 'pointer' }}>Tutto</div></li>
                                <li><div onClick={this.filtraMedia.bind(this, 'isFoto')} style={visibile === 'isFoto' ? { background: accento, color: '#fff', cursor: 'default' } : { background: '#fff', cursor: 'pointer' }}>Foto</div></li>
                                <li><div onClick={this.filtraMedia.bind(this, 'isVideo')} style={visibile === 'isVideo' ? { background: accento, color: '#fff', cursor: 'default' } : { background: '#fff', cursor: 'pointer' }}>Video</div></li>
                            </ul>
                        </div>
                        <div className="uk-float-left">
                            <h2 className="uk-text-bold uk-text-uppercase"><Bullet colore={this.state.accento} />Portfolio</h2>
                        </div>
                    </div>


                    <div className="js-filter uk-margin-small-top uk-grid-small uk-grid-match uk-child-width-1-3@s" data-uk-grid data-uk-scrollspy="cls: uk-animation-fade; target: > div; delay: 90;">
                        {currentMedia && currentMedia.map((item, index) =>


                            <div key={index}>

                                <div className="uk-inline-clip uk-transition-toggle ">

                                    {item.contentType.includes('image') ?

                                        <div style={{ cursor: 'pointer' }} onClick={this.showLightbox.bind(this, index + (currentPage - 1) * perPage)}>
                                            <div
                                                className="uk-height-medium uk-background-cover"
                                                data-src={item.url}
                                                data-uk-img
                                                alt={item.descBreve}
                                            />
                                            <div className="uk-transition-fade uk-position-cover uk-position-small uk-overlay uk-overlay-default uk-flex uk-flex-center uk-flex-middle">
                                                <span className="uk-margin-remove" data-uk-icon="icon: plus; ratio: 3" />
                                            </div>
                                        </div>

                                        :

                                        <div
                                            className="uk-position-relative uk-height-medium"
                                            onClick={this.showLightbox.bind(this, index + (currentPage - 1) * perPage)}
                                            style={{ cursor: 'pointer', overflow: 'hidden' }}>

                                            <div className="uk-card-badge uk-label" style={{ background: accento, color: '#fff' }}>Video</div>

                                            <video loop muted playsInline
                                                style={{
                                                    top: 0,
                                                    left: 0,
                                                    position: 'absolute',
                                                    objectFit: 'cover',
                                                    objectPosition: 'center top',
                                                    height: '100%',
                                                    width: '100%',
                                                }}
                                            >
                                                <source src={item.url} type={item.contentType} />
                                            </video>

                                            <div className="uk-transition-fade uk-position-cover uk-position-small uk-overlay uk-overlay-default uk-flex uk-flex-center uk-flex-middle">
                                                <span className="uk-margin-remove" data-uk-icon="icon: play; ratio: 3.5" />
                                            </div>

                                        </div>

                                    }
                                </div>
                            </div>

                        )}
                    </div>

                    <ul className="uk-pagination uk-flex-center pagi" data-uk-margin>

                        {pageNumbers.map((numero) =>
                            <li key={numero} >
                                <a href="#portfolio"
                                    data-uk-scroll="duration: 600"
                                    onClick={() => setTimeout(this.cambiaPagina.bind(this, numero), 600)}
                                    style={currentPage === numero ? { background: accento, color: '#fff', cursor: 'default' } : { background: '#fff' }}>
                                    {numero}
                                </a>
                            </li>

                        )}

                    </ul>

                </div>

            </div>

        )
    }
}

export default Portfolio


// WEBPACK FOOTER //
// ./src/components/sito/temi/layoutorizzontale/portfolio/index.js